import { useCallback, useEffect, useRef } from 'react';

/**
 * @description component mount custom hook
 * @Class
 * @category hooks
 * @subcategory hooks
 * @returns {boolean}
 */
function useIsMounted() {
  const isMounted = useRef(false);
  const isMountedFunction = useCallback(() => isMounted.current, []);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMountedFunction;
}

export default useIsMounted;
